import { render, staticRenderFns } from "./ProcessEmailModel.vue?vue&type=template&id=a2ad7868"
import script from "./ProcessEmailModel.vue?vue&type=script&lang=js"
export * from "./ProcessEmailModel.vue?vue&type=script&lang=js"
import style0 from "./ProcessEmailModel.vue?vue&type=style&index=0&id=a2ad7868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports